import type { CheckoutUrlRootBuilder } from './CheckoutUrlRootBuilder';

/** Post-checkout success hooks (room to grow beyond a redirect). */
export class SuccessHooks {
  constructor(private readonly root: CheckoutUrlRootBuilder) {}

  redirectTo(url: string): this {
    this.root.param('redirect_to', url);
    return this;
  }
}
